import { Component, OnInit, ElementRef, ViewChildren, AfterViewInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControlName, UntypedFormBuilder, Validators } from '@angular/forms';

import { Observable, fromEvent, merge, Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxBrazilMASKS, NgxBrazilValidators } from 'ngx-brazil';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { BuyerDadosConviteService } from './dados-convite.service';
import { NotificationService } from 'app/_services/notification.service';

import { Globals } from 'app/_models/globals';
import { GenericValidator, ValidationMessages, DisplayMessage } from 'app/_utils/generic-form-validation';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { DomainNotification } from 'app/_models/domainNotification';

declare const isEmpty: any;

@Component({
    selector: 'app-dados-convite', templateUrl: './dados-convite.component.html', styleUrls: ['./dados-convite.component.scss'],
    standalone: false
})
export class BuyerDadosConvitesComponent implements OnInit, AfterViewInit {
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    @Input() loading_local: boolean;
    @Input() notifier: Subject<boolean>;

    conviteForm: UntypedFormGroup;
    displayMessage: DisplayMessage = {};
    errors: any[] = [];
    genericValidator: GenericValidator;
    validationMessages: ValidationMessages;

    public MASKS: any = NgxBrazilMASKS;
    modalRef: BsModalRef;

    Swal: any;
    loading: boolean;

    constructor(
        private conviteService: BuyerDadosConviteService,
        private notificationService: NotificationService,
        private globals: Globals,
        private fb: UntypedFormBuilder,
        private ngxLoader: NgxUiLoaderService) { }

    ngOnInit() {
        this.validationMessages = {
            company_name: { required: this.globals.translate('buyer.convidar.dados-convite.empresa.obrigatorio') },
            seller_name: { required: this.globals.translate('buyer.convidar.dados-convite.nome.obrigatorio') },
            seller_email: { required: this.globals.translate('buyer.convidar.dados-convite.email.obrigatorio'), email: this.globals.translate('buyer.convidar.dados-convite.email.formato-invalido') },
            seller_phone: { required: this.globals.translate('buyer.convidar.dados-convite.telefone.obrigatorio'), telefone: this.globals.translate('buyer.convidar.dados-convite.telefone.formato-invalido') },
            seller_radio: { telefone: this.globals.translate('buyer.convidar.dados-convite.whatsapp.formato-invalido') }
        };

        this.genericValidator = new GenericValidator(this.validationMessages);

        this.conviteForm = this.fb.group({
            company_name: ['', [Validators.required]],
            seller_name: ['', [Validators.required]],
            seller_email: ['', [Validators.required, Validators.email]],
            seller_phone: ['', [Validators.required, NgxBrazilValidators.phoneNumber]],
            seller_radio: ['', [NgxBrazilValidators.phoneNumber]]
        });

        if (!isEmpty(this.notifier)) {
            this.notifier.subscribe(data => { if (data) { this.salvar(1); } });
        }
    }

    ngAfterViewInit(): void {
        let controlBlurs: Observable<any>[] = this.formInputElements.map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
        merge(...controlBlurs).subscribe(() => { this.displayMessage = this.genericValidator.processarMensagens(this.conviteForm); });
    }

    salvar(nAttempts: number) {
        if (this.conviteForm.dirty && this.conviteForm.valid) {
            if (this.loading_local)
                this.loading = true;
            else
                this.ngxLoader.startLoader('loader-principal');

            let convite = this.conviteForm.value;

            this.conviteService.add(convite).subscribe({
                next: async (response: ApiResponseModel<{ notifications: DomainNotification[] }>) => {
                    if (response && response.result.notifications.length > 0) {
                        var msg = response.result.notifications[0].value.trim();
                        var titulo = msg.split(';')[0];
                        var corpo = msg.split(';')[1];

                        if (response.success)
                            this.notificationService.showSuccessToastr(corpo);
                        else
                            await this.notificationService.showWarning(corpo, titulo, false, false);

                        this.conviteForm.reset();

                        if (this.loading_local)
                            this.loading = false;
                        else
                            this.ngxLoader.stopLoader('loader-principal');
                    }
                },
                error: error => {
                    nAttempts = nAttempts || 1;
                    console.log(error, nAttempts);

                    if (nAttempts >= 5) {
                        if (this.loading_local)
                            this.loading = false;
                        else
                            this.ngxLoader.stopLoader('loader-principal');

                        return;
                    }

                    this.salvar(++nAttempts);
                }
            });
        }
    }
}
